// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PartnershipsRouteImport } from './routes/partnerships'
import { Route as MediaRouteImport } from './routes/media'
import { Route as InvestorDisclaimerRouteImport } from './routes/investor-disclaimer'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PartnershipPackageTokenRouteImport } from './routes/partnership-package.$token'
import { Route as InvestorDeckTokenRouteImport } from './routes/investor-deck.$token'
import { Route as AuthenticatedAdminInvestorLeadsRouteImport } from './routes/_authenticated/admin/investor-leads'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PartnershipsRoute = PartnershipsRouteImport.update({
            id: '/partnerships',path: '/partnerships',getParentRoute: () => rootRouteImport
          })
const MediaRoute = MediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => rootRouteImport
          })
const InvestorDisclaimerRoute = InvestorDisclaimerRouteImport.update({
            id: '/investor-disclaimer',path: '/investor-disclaimer',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PartnershipPackageTokenRoute = PartnershipPackageTokenRouteImport.update({
            id: '/partnership-package/$token',path: '/partnership-package/$token',getParentRoute: () => rootRouteImport
          })
const InvestorDeckTokenRoute = InvestorDeckTokenRouteImport.update({
            id: '/investor-deck/$token',path: '/investor-deck/$token',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminInvestorLeadsRoute = AuthenticatedAdminInvestorLeadsRouteImport.update({
            id: '/admin/investor-leads',path: '/admin/investor-leads',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminInvestorLeadsRoute: AuthenticatedAdminInvestorLeadsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,InvestorDisclaimerRoute: InvestorDisclaimerRoute,MediaRoute: MediaRoute,PartnershipsRoute: PartnershipsRoute,PrivacyRoute: PrivacyRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,InvestorDeckTokenRoute: InvestorDeckTokenRoute,PartnershipPackageTokenRoute: PartnershipPackageTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)